import React, { PureComponent } from 'react';
import withRouterLegacy from 'components/withRouterLegacy';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'utils/compose';

import { accountsSelectors } from 'companion-app-components/flux/accounts';
import { chartOfAccountsUtils, chartOfAccountsSelectors } from 'companion-app-components/flux/chart-of-accounts';

import zeroStateIcon from 'assets/zero-state-images/safebox.svg';

import * as transactionSelectors from 'data/transactions/selectors';
import * as transactionListSelectors from 'data/transactionList/selectors';

import { isOldEdge } from 'utils/utils';

import LoadingView from 'components/LoadingView';
import ZeroStateView from 'components/ZeroStateView';

import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import { withStyles } from 'tss-react/mui';
import { withTheme } from '@emotion/react';
import Fade from '@mui/material/Fade';

import Transaction from './Transaction';
import { computeViewState } from '../helpers';

const styles = () => ({
  root: {
    height: '100%',
  },
  listItemRoot: {
    padding: '0 20px',
    borderBottom: 'none',
  },
});

// import { getLogger } from 'utils/logger';
// const log = getLogger('components/Transactions/index.js');

const isIe = require('is-iexplorer') || isOldEdge();  // eslint-disable-line
const MAX_UPCOMING_TXNS = 5;

class Transactions extends PureComponent {

  static propTypes = {
    acctTxns: PropTypes.any,
    classes: PropTypes.object,
    router: PropTypes.object,
    coaNodesById: PropTypes.object,
    hasReportableAccounts: PropTypes.bool,
    isLoading: PropTypes.bool,
    txnsToShow: PropTypes.string,
    zeroStateWithAction: PropTypes.object,
  };

  getCategoryName = (coaNode) => {
    const currentCoaId = chartOfAccountsUtils.getCoaId(coaNode, true);
    const { coaNodesById } = this.props;
    const currentCoaNode = coaNodesById ? coaNodesById.get(currentCoaId) : null;
    return currentCoaNode ? currentCoaNode.fullPathName : '';
  };

  clickTransaction = (e) => {
    e.stopPropagation();
    let url;
    if (this.props.txnsToShow === 'upcoming') {
      // only commenting these out for now as when the new ACME Bills-and-Income page is built we are bringing it back.
      // const transactionFound = this.props.acctTxns.find((transaction) => transaction.id === e.currentTarget.dataset.transactionid);
      // url = `/bills-and-income?selectNode=${transactionFound && transactionFound.stModelId}`;
      url = `/transactions?displayNode=${e.currentTarget.dataset.accountid}&txnId=${e.currentTarget.dataset.transactionid}`;
    } else {
      url = `/transactions?displayNode=${e.currentTarget.dataset.accountid}&txnId=${e.currentTarget.dataset.transactionid}`;
    }
    this.props.router.navigate(url);
  };

  dataIsNull = () => this.props.isLoading;

  dataIsEmpty = () => !this.dataIsNull() && this.props.acctTxns.size === 0;

  // Below for zero state in Simplifi
  routeToManage = () => this.props.router.navigate('/settings?selectedNode=Recurring');

  render() {
    const { acctTxns, classes, hasReportableAccounts, zeroStateWithAction } = this.props;
    const view = computeViewState(this.dataIsNull, this.dataIsEmpty, hasReportableAccounts);
    const numTransactions = acctTxns ? acctTxns.size : 0;

    return (
      <div className={classes.root}>
        {view === 'loading' &&
        <LoadingView />}
        {(view === 'zero' || view === 'empty') &&
        <ZeroStateView
          onClick={zeroStateWithAction && this.routeToManage}
          icon={zeroStateIcon}
          primary={zeroStateWithAction ? zeroStateWithAction.primaryText : 'No Recent Transactions'}
          secondary="Your most recent transactions from all your financial accounts will display here. "
          size="small"
        />}
        {view === 'main' &&
          <div style={{ cursor: 'pointer', height: '100%' }}>
            <List>
              {numTransactions > 0 && acctTxns.map((txn, i) => (
                <Fade
                  key={txn.id}
                  appear
                  in
                >
                  <ListItem
                    button
                    divider={i !== numTransactions - 1}
                    data-transactionid={txn.id}
                    data-accountid={txn.accountId}
                    style={{ transitionDelay: `${i * 0.05}s` }}
                    onClick={this.clickTransaction}
                    classes={{
                      root: classes.listItemRoot,
                    }}
                    id={`recent-txn-${i}`}
                  >
                    <Transaction txn={txn} category={this.getCategoryName(txn.coa)} />
                  </ListItem>
                </Fade>
              ))}
            </List>
          </div>}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  // Recent transactions to be shown by default
  // Upcomming transactions to be shown if txnsToShow = 'upcoming'
  const txns = ownProps.txnsToShow === 'upcoming' ?
    transactionListSelectors.getProjectedTxnList(state, {
      maxTxns: MAX_UPCOMING_TXNS,
    }) :
    transactionListSelectors.getRecentTransactions(state, {
      accountIds: null,
      ...ownProps,
    });

  return {
    isLoading: transactionSelectors.getLoadPending(state),
    hasReportableAccounts: accountsSelectors.getHasReportableAccounts(state, ownProps),
    coaNodesById: chartOfAccountsSelectors.getChartOfAccountNodesById(state, ownProps),
    acctTxns: txns,
  };
}

export default compose(
  withTheme,
  withRouterLegacy,
  connect(mapStateToProps),
)(withStyles(Transactions, styles));

